import { TextField } from "@material-ui/core";
import React, { FC, memo } from "react";
import { FormTextFieldProps } from "./types";

const FormTextField: FC<FormTextFieldProps> = ({ showError, required, ...props }) => {
  const { InputProps = {}, InputLabelProps, validationSuccess, ...restProps } = props;

  return (
    <TextField
      InputProps={{
        ...InputProps,
        required,
      }}
      InputLabelProps={InputLabelProps}
      {...restProps}
      variant="outlined"
    />
  );
};

export default memo(FormTextField);
